module.exports = __webpack_public_path__ + "img/ofertastodoelaño.e26ed327.png";